import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchReferences, getItemImage, getItemSlug, optimizeImageUrl } from '../lib/cms';
import { siteConfig } from '../data';

export default function References() {
  const [references, setReferences] = useState(siteConfig.references || []);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function loadData() {
      const res = await fetchReferences({ limit: 100 });
      if (isMounted) {
        if (res && res.items && res.items.length > 0) {
          setReferences(res.items);
        }
        setLoading(false);
      }
    }
    loadData();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="pt-8 md:pt-12 pb-24 animate-in fade-in duration-1000">
      <div className="max-w-5xl mx-auto px-6">
        <header className="mb-24">
          <h1 className="text-3xl md:text-4xl font-serif text-slate-900 mb-6">Referencer</h1>
          <p className="text-lg text-slate-500 font-light max-w-2xl">
            Et udvalg af tidligere projekter og opgaver.
          </p>
        </header>

        {loading && references.length === 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
            {[1, 2, 3, 4, 5, 6].map((n) => (
              <div key={n} className="animate-pulse">
                <div className="aspect-[4/3] bg-slate-100 mb-6 rounded-none" />
                <div className="h-6 bg-slate-100 w-3/4 mb-3" />
                <div className="h-4 bg-slate-100 w-1/4 mb-3" />
                <div className="h-4 bg-slate-100 w-full mb-2" />
                <div className="h-4 bg-slate-100 w-2/3" />
              </div>
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
            {references.map((item, index) => {
              const slug = getItemSlug(item);
              const rawImg = getItemImage(item);
              const imgUrl = optimizeImageUrl(rawImg, 'width=800,quality=80,format=auto');

              return (
                <Link
                  key={item.id || slug || index}
                  to={`/referencer/${slug}`}
                  className="group block"
                >
                  <div className="aspect-[4/3] overflow-hidden bg-slate-50 mb-6">
                    {imgUrl ? (
                      <img
                        src={imgUrl}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-all duration-700"
                        loading="lazy"
                      />
                    ) : (
                      <div className="w-full h-full bg-slate-100 flex items-center justify-center text-slate-300">
                        Intet billede
                      </div>
                    )}
                  </div>
                  <h2 className="text-lg font-serif text-slate-900 mb-2 group-hover:text-slate-600 transition-colors">
                    {item.title}
                  </h2>
                  {item.category && (
                    <p className="text-sm text-slate-400 mb-3 uppercase tracking-wider">
                      {item.category}
                    </p>
                  )}
                  {item.description && (
                    <p className="text-slate-500 text-sm leading-relaxed font-light">
                      {item.description}
                    </p>
                  )}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
